import {useLocaleStore} from '@frontend/stores'
import type {LanguageConfig} from '@frontend/types/Locales'

// Хук для получения настроек языка.
export const useLanguageConfig = (): LanguageConfig => useLocaleStore(
    state => state.language
)
